document.addEventListener('DOMContentLoaded', function () {
  function updateCartCount(itemCount) {
    document.querySelectorAll('.ajax-cart-count.bigcounter').forEach(el => {
      const visible = el.querySelector('span[aria-hidden="true"]');
      const hidden = el.querySelector('.visually-hidden');
      if (visible) visible.textContent = itemCount;
      if (hidden) hidden.textContent = `${itemCount} item${itemCount !== 1 ? 's' : ''}`;
    });
  }

  function enableCheckoutWhenChecked() {
    const checkbox = document.querySelector('#toggleCheckbox');
    const checkoutBtn = document.querySelector('#ajaxcart-checkout');
    if (checkbox && checkoutBtn) {
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          checkoutBtn.removeAttribute('disabled');
        } else {
          checkoutBtn.setAttribute('disabled', 'disabled');
        }
      });

      // Initialize state
      if (checkbox.checked) {
        checkoutBtn.removeAttribute('disabled');
      } else {
        checkoutBtn.setAttribute('disabled', 'disabled');
      }
    }
  }

  function waitForValidCart(attempts = 10, delay = 300, openDrawer = false) {
    let tries = 0;
    const poll = setInterval(() => {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          if (cart.item_count > 0 || tries >= attempts) {
            updateCartCount(cart.item_count);

            if (openDrawer) {
              const cartIcon = document.querySelector('[data-cart-toggle], .header__icon--cart, .cart-count');
              if (cartIcon) {
                cartIcon.click();

                // Wait for drawer DOM to fully render
                setTimeout(enableCheckoutWhenChecked, 500);
              }
            }

            clearInterval(poll);
          }
        })
        .catch(() => {});

      tries++;
    }, delay);
  }

  const addForm = document.querySelector('form[action="/cart/add"]');
  if (addForm) {
    addForm.addEventListener('submit', () => {
      waitForValidCart(10, 400, true); // Open drawer after add
    });
  }

  document.querySelectorAll('form[action="/cart/change"]').forEach(form => {
    form.addEventListener('submit', () => {
      setTimeout(() => waitForValidCart(5, 300, false), 600);
    });
  });

  document.addEventListener('click', function (e) {
    const removeBtn = e.target.closest('[data-action="remove"], .remove, [data-remove]');
    if (removeBtn) {
      setTimeout(() => waitForValidCart(5, 300, false), 600);
    }
  });

  // Just in case it's open already on load
  enableCheckoutWhenChecked();
});